import NotificationsSocket from './NotificationsSocket.js';
import settings from './settings.js';
import api from './raymanAPI.js';
import EventsDispatcher from 'controllers/EventsDispatcher.js';
//import NotificationsSoundController from 'controllers/NotificationsSound';

class Singletons extends EventsDispatcher
{
    constructor()
    {
        super();

        this.NotificationsSocket = undefined;
        this.currentUser = undefined;
        this.initialized = false;
        this.userProfiles = {admin: false, expert: false, operator: false}
    }

    Initialize(currentUser)
    {
        this.currentUser = currentUser;
        this.userProfiles = {
            admin: currentUser.profiles.indexOf("administrators") > -1,
            expert: currentUser.profiles.indexOf("experts") > -1,
            operator: currentUser.profiles.indexOf("operators") > -1
          }
        this.NotificationsSocket = new NotificationsSocket(settings.connections.notificationsSocketURL, api.internalApi.token);
        this.NotificationsSocket.on('socketConnected', () => {this.currentUser.state = "available"});
        this.NotificationsSocket.on('socketDisconnected', () => {this.currentUser.state = "disconnected"});
        this.initialized = true;
        //this.soundController = new NotificationsSoundController(this.NotificationsSocket);
        this.dispatch("userLoggedIn", {currentUser: currentUser, notificationsSocket: this.NotificationsSocket});
    }
}

const singleton = new Singletons();

export default singleton;
